import { GridRowProps } from '@mui/x-data-grid';

import { useTranslation } from 'react-i18next';

import { GridRowWithTooltip } from 'app/components/GridRowWithTooltip';
import { translations } from 'locales/i18n';

import './BookingRowWithTooltip.scss';

export const BookingRowWithTooltip = (params: GridRowProps) => {
  const { t } = useTranslation();

  return (
    <GridRowWithTooltip
      {...params}
      tooltip={
        params.row.deletedAt !== null
          ? t(translations.pages.leihbar.tooltips.bookingCanceled())
          : ''
      }
    />
  );
};
